import React, { useEffect, useState } from 'react'
import { Badge, makeStyles, Paper, Snackbar, Tab, Tabs } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import TabAntrian from './tabAntrian';
import LoadingComponent from '../../components/loading';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: "100%",
        backgroundColor: theme.palette.background.paper
    },
    tabsIndicator: {
        backgroundColor: "#2a9c6c"
    },
    tabRoot: {
        "&:hover": {
            color: "red",
            opacity: 1
        },
        "&$tabSelected": {
            color: "red",
            fontWeight: theme.typography.fontWeightMedium
        },
        "&:focus": {
            color: "red"
        }
    },
    tabSelected: {},
    fab: {
        '& > *': {
            margin: theme.spacing(1),
        },
        position: 'fixed',
        right: 25,
        top: 65
    },
    extendedIcon: {
        marginRight: theme.spacing(1)
    },
}))

const TabDetailPemanggilan = (props) => {
    const classes = useStyles()
    const [loading, setLoading] = useState(true)
    const [indexTab, setIndexTab] = useState(0)
    const [messageAlert, setMessageAlert] = useState("")
    const [statusAlert, setStatusAlert] = useState("")
    const [openAlert, setOpenAlert] = useState(false);
    const [totalData, setTotalData] = useState([
        { total: 0 },
        { total: 0 },
    ])

    useEffect(() => {
        setLoading(true)
    }, [indexTab])


    const listTab = [
        "List Antrian",
        "List Antrian Terlewat"
    ]

    const handleChangeTab = (event, newValue) => {
        setIndexTab(newValue);
    };

    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    }

    const handleTotalData = (_totalData, _indexTab) => {
        const tmp = totalData
        tmp[_indexTab].total = _totalData
        setTotalData(tmp)
    }

    return (
        <div>
            <LoadingComponent isVisible={loading} />
            <Paper style={{ boxShadow: 'none' }} >
                <div style={{ width: '100%', display: 'grid' }}>
                    <Snackbar open={openAlert} autoHideDuration={2000} onClose={handleCloseAlert}>
                        <Alert onClose={handleCloseAlert} severity={statusAlert}>
                            {messageAlert}
                        </Alert>
                    </Snackbar>
                </div>
                <Tabs
                    value={indexTab}
                    indicatorColor="primary"
                    textColor="#2a9c6c"
                    onChange={handleChangeTab}
                    aria-label="disabled tabs example"
                    style={{ outline: 'null' }}
                    classes={{ indicator: classes.tabsIndicator }}
                >
                    {listTab?.map((item, index) => {
                        return (
                            <Tab
                                label={<Badge badgeContent={totalData[index]?.total || 0} color="primary">
                                    {item}
                                </Badge>} style={{ color: indexTab === index ? '#2a9c6c' : 'black' }} />
                        )
                    })}
                </Tabs>
            </Paper>
            <TabAntrian
                indexTab={indexTab}
                handleTotalData={handleTotalData}
                setLoading={(val) => {
                    setLoading(val)
                }}
                loading={loading}
                setOpenAlert={(val) => {
                    setOpenAlert(val)
                }}
                openAlert={openAlert}
                setMessageAlert={(val) => {
                    setMessageAlert(val)
                }}
                messageAlert={messageAlert}
                setStatusAlert={(val) => {
                    setStatusAlert(val)
                }}
                propsPip={props}
            />
            {/* {indexTab === 1 &&
                <TabAntrianTerlewati
                    indexTab={indexTab}
                    handleTotalData={handleTotalData}
                    setLoading={(val) => {
                        setLoading(val)
                    }}
                    loading={loading}
                    setOpenAlert={(val) => {
                        setOpenAlert(val)
                    }}
                    setMessageAlert={(val) => {
                        setMessageAlert(val)
                    }}
                    setStatusAlert={(val) => {
                        setStatusAlert(val)
                    }}
                    propsPip={props}
                    setTabProcessActive={(val) => {
                        setTabProcessActive(val)
                    }}
                    tabProcessActive={tabProcessActive}
                />
            } */}
        </div>
    )
}

export default TabDetailPemanggilan